import { Route, Routes, Navigate } from 'react-router-dom';

import { PERMISSION } from 'src/features/auth';
import Details from 'src/features/profile/routes/Details';
import Email from 'src/features/profile/routes/Email';
import Password from 'src/features/profile/routes/Password';
import Settings from 'src/features/profile/routes/Settings';
import useHasPermissions from 'src/hooks/useHasPermissions.ts';

const ProfileRoutes = () => {
    const permissionProfile = useHasPermissions([PERMISSION.PROFILE]);
    return permissionProfile ? (
        <Routes>
            <Route path="" element={<Details />} />
            <Route path="email" element={<Email />} />
            <Route path="password" element={<Password />} />
            <Route path="settings" element={<Settings />} />
            <Route path="*" element={<Navigate to=".." />} />
        </Routes>
    ) : (
        <Navigate to=".." />
    );
};

export default ProfileRoutes;
